import { IconAdd } from '@consta/icons/IconAdd'
import { IconCollapse } from '@consta/icons/IconCollapse'
import { IconExpand } from '@consta/icons/IconExpand'
import { IconTrash } from '@consta/icons/IconTrash'
import type { Props as ButtonProps } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import { GroupingHeader } from '@core/components'
import { getSimpleTooltipContent } from '@core/core/helpers'
import type { FC } from 'react'
import { useEffect, useState } from 'react'

import { ButtonWithTooltip, MAX_SELECT_ITEM_LENGTH } from '../constants'
import type { LayersMenuActionsProps } from './types'

const buttonProps: ButtonProps = {
  size: 'xs',
  view: 'secondary',
  onlyIcon: true,
}

const collapseAllLayersTooltip = getSimpleTooltipContent('Свернуть все слои')
const deployAllLayersTooltip = getSimpleTooltipContent('Развернуть все слои')
const removeAllLayersTooltip = getSimpleTooltipContent('Удалить все слои')

const layersInfoTooltip = (
  <Text size="xs" view="primary">
    <div>Граница слоя ― нижняя граница данного слоя</div>
    <div>
      V(t)<sub>min</sub>, V(t)<sub>max</sub>, м/с ― относятся к слою
    </div>
    <div> STD, м ― среднеквадратичное отклонение</div>
    <div> на границе слоя</div>
    <div>
      R<sup>2</sup> ― коэффициент детерминации
    </div>
  </Text>
)

export const LayersMenuActions: FC<LayersMenuActionsProps> = ({
  addedSelectItemList,
  createSelectItem,
  removeAllLayers,
  updateSelectItemList,
}) => {
  const isItemsCollapsed = !!addedSelectItemList.find(i => i.isCollapsed)
  const [isAllItemsCollapsed, setAllItemsCollapsed] = useState(isItemsCollapsed)
  const content = isAllItemsCollapsed ? deployAllLayersTooltip : collapseAllLayersTooltip

  const onCollapseAll = () => {
    updateSelectItemList(selectedLayersList =>
      selectedLayersList.map(layer => ({
        ...layer,
        isCollapsed: true,
      })),
    )
    setAllItemsCollapsed(true)
  }

  const onDeployAll = () => {
    updateSelectItemList(selectedLayersList =>
      selectedLayersList.map(layer => ({
        ...layer,
        isCollapsed: false,
      })),
    )
    setAllItemsCollapsed(false)
  }

  useEffect(() => {
    setAllItemsCollapsed(isItemsCollapsed)
  }, [addedSelectItemList])

  const ButtonCollapseAllLayersToShow = (
    <ButtonWithTooltip
      tooltipProps={{ content }}
      {...buttonProps}
      view="ghost"
      iconLeft={isAllItemsCollapsed ? IconExpand : IconCollapse}
      disabled={!addedSelectItemList.length}
      onClick={isAllItemsCollapsed ? onDeployAll : onCollapseAll}
    />
  )

  const ButtonRemoveAllLayersToShow = (
    <ButtonWithTooltip
      tooltipProps={{ content: removeAllLayersTooltip }}
      view="ghost"
      onlyIcon={true}
      size="xs"
      iconLeft={IconTrash}
      disabled={!addedSelectItemList.length}
      onClick={removeAllLayers}
    />
  )

  return (
    <GroupingHeader title="Слои" info={layersInfoTooltip}>
      {addedSelectItemList.length < MAX_SELECT_ITEM_LENGTH && (
        <Button
          iconLeft={IconAdd}
          size="xs"
          onlyIcon={true}
          view="ghost"
          onClick={createSelectItem}
        />
      )}
      {ButtonCollapseAllLayersToShow}
      {ButtonRemoveAllLayersToShow}
    </GroupingHeader>
  )
}
